interface AppRoute {
    AUTH: {
        LOGIN: string;
    };

    MAIN: {
        ROOT: string;
        LIST_DETAIL: string;
        LIST_STATUS: string;
        CHECK_IN: string;
        ORDER: string;
    };
    ADMIN: {
        ROOT: string;
        MANAGEMENT: {
            ROOT: string;
            REPORT: string;
            HISTORY: string;
        };
        ROOM: {
            ROOT: string;
            FLOOR: string;
            FLOOR_ADD: string;
            FLOOR_UPDATE: string;
            CATEGORY: string;
            CATEGORY_ADD: string;
            CATEGORY_UPDATE: string;
        };
        THU_CHI: {
            ROOT: string;
            THU_CHI_ADD: string;
            THU_CHI_UPDATE: string;
        };
        SERVICE: {
            ROOT: string;
            DANHMUC_ADD: string;
            DANHMUC_UPDATE: string;
            ITEM: string;
            ITEM_UPDATE: string;
            ITEM_ADD: string;
        };
    };
    NOT_FOUND: string;
}

export const appRoutes: AppRoute = {
    AUTH: {
        LOGIN: '/login',
    },

    MAIN: {
        ROOT: '/',
        LIST_DETAIL: '/list-detail',
        LIST_STATUS: '/ist-status',
        CHECK_IN: '/check-in',
        ORDER: '/order',
    },
    ADMIN: {
        ROOT: '/',
        MANAGEMENT: {
            ROOT: '/management',
            REPORT: '/report',
            HISTORY: '/history',
        },
        ROOM: {
            ROOT: '/room',
            FLOOR: '/floor',
            FLOOR_ADD: '/floor/add',
            CATEGORY: '/category',
            FLOOR_UPDATE: '/floor/update',
            CATEGORY_UPDATE: '/category/update',
            CATEGORY_ADD: '/category/add',
        },
        THU_CHI: {
            ROOT: '/thu_chi',
            THU_CHI_ADD: '/thu_chi/add',
            THU_CHI_UPDATE: '/thu_chi/update',
        },
        SERVICE: {
            ROOT: '/service',
            DANHMUC_ADD: '/service/add',
            DANHMUC_UPDATE: '/service/update',
            ITEM: '/item',
            ITEM_UPDATE: '/item/update',
            ITEM_ADD: '/item/add',
        },
    },
    NOT_FOUND: '404',
};
